import { useEffect, useState } from "react";

const SCROLL_SPY_OFFSET = 160;

/**
 * Highlights the nav item for the section currently in view.
 * Replaces jQuery Waypoints scroll-spy from main.js.
 */
export function useSectionSpy(navSectionKeys, defaultSection = "home") {
  const [activeSection, setActiveSection] = useState(defaultSection);

  useEffect(() => {
    const resolveActiveSection = () => {
      const sections = document.querySelectorAll("section[data-section]");
      let current = defaultSection;

      sections.forEach((section) => {
        const navKey = section.dataset.section;
        if (!navSectionKeys.includes(navKey)) {
          return;
        }
        if (section.offsetTop <= window.scrollY + SCROLL_SPY_OFFSET) {
          current = navKey;
        }
      });

      setActiveSection(current);
    };

    resolveActiveSection();
    window.addEventListener("scroll", resolveActiveSection, { passive: true });
    window.addEventListener("resize", resolveActiveSection);

    return () => {
      window.removeEventListener("scroll", resolveActiveSection);
      window.removeEventListener("resize", resolveActiveSection);
    };
  }, [navSectionKeys, defaultSection]);

  return activeSection;
}
